import { Component, Input } from "@angular/core";
import { StorageService, UserService, ProductService, CheckoutService } from "@mypxplat/xplat/core";
import { UpgradeSoftwareBaseComponent } from "@mypxplat/xplat/features";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslateService } from "@ngx-translate/core";
import { Router } from "@angular/router";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-upgrade-software",
  templateUrl: "upgrade-software.component.html",
  standalone: false,
})
export class UpgradeSoftwareComponent extends UpgradeSoftwareBaseComponent {
  private shortMask: any = [/\w/, /\w/, /\w/, /\w/, "-", /\w/, /\w/, /\w/, /\w/, "-", /\w/, /\w/, /\w/, /\w/, "-", /\w/, /\w/, /\w/, /\w/, "-", /\w/, /\w/, /\w/, /\w/];
  private longMask: any = [
    /\w/,
    /\w/,
    /\w/,
    /\w/,
    "-",
    /\w/,
    /\w/,
    /\w/,
    /\w/,
    "-",
    /\w/,
    /\w/,
    /\w/,
    /\w/,
    "-",
    /\w/,
    /\w/,
    /\w/,
    /\w/,
    "-",
    /\w/,
    /\w/,
    /\w/,
    /\w/,
    "-",
    /\w/,
    /\w/,
    /\w/,
    /\w/,
    "-",
    /\w/,
    /\w/,
    /\w/,
    /\w/,
  ];
  public mask = this.longMask;
  public loadingOptions: boolean = false;
  constructor(
    storageService: StorageService,
    userService: UserService,
    public productService: ProductService,
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    private _router: Router,
    public appService: AppService,
    public checkoutService: CheckoutService
  ) {
    super(storageService, userService, productService, translate);
  }

  keyPressed(args) {
    let tester = /\w/;
    // dont do anything if its a single key and its not alphanumeric.
    if (args.key.length == 1 && !tester.test(args.key)) {
      return false;
    } else if (this.productKey) {
      let rawKey = this.productKey.replace(/_|-/g, "");
      if (args.key == "Backspace" && rawKey.length == 21) {
        this.mask = this.shortMask;
      } else if (rawKey.length > 19) {
        this.mask = this.longMask;
      } else {
        this.mask = this.shortMask;
      }
    }
  }

  performUpgrade() {
    let rawKey = this.productKey.replace(/_|-/g, "");
    if (this.productKey.includes("-____-____")) {
      this.productKey = this.productKey.slice(0, -10);
    }
    if (rawKey.length == 20 || rawKey.length == 28) {
      let args: any = {
        oldProductKey: this.upgradingProduct.license.productKeyString,
        productKey: this.productKey,
      };
      if (this.isAdmin) {
        args.admin = true;
        if (!this.userId) {
          alert("User ID is required for admin upgrade.");
          return;
        }
        args.userId = this.userId;
      }
      this.loading = true;
      this.productService.performUpgrade(args).subscribe({
        next: (result) => {
          if (this.isAdmin) {
            this.upgradeComplete.next(result);
            this.loading = false;
            this.activeModal.close();
          } else {
            this.productService.getProducts(true).subscribe((newProds) => {
              this.loading = false;
              this.activeModal.close();
              // find the new product in the list of products using the licenseId
              let upgradedTo = newProds.products.filter((prod) => prod.assetIds.includes(result.licenseId.toString()));
              if (upgradedTo.length) {
                this._router.navigate(["products/detail/", upgradedTo[0].id]);
              }
            });
          }
        },
        error: (error) => {
          this.loading = false;
          this.appService.alertError(error);
          this.productKey = "";
        },
      });
    } else {
      alert("Please make sure the key you are entering is exactly 20 or 28 characters.");
    }
  }

  goToCheckout() {
    this.loadingOptions = true;
    this.checkoutService.getUpgradableProducts(null, this.upgradingProduct.licenseScheme == 1 ? "Notion" : "Studio One").subscribe((result) => {
      this.loadingOptions = false;
      let productId = result.data?.products?.length ? result.data.products[0].id : null;
      this.appService.goToCheckout("/checkout?checkoutProductType=Upgrade", productId);
    });
  }
}
